import React, { useState, useEffect, useRef } from 'react';
import { AppBar, Toolbar, Typography, Button, Stack, Box } from '@mui/material';

type NavBarProps = {
  title?: string;
  showSectionNav?: boolean;
};

export default function NavBar({ title, showSectionNav = false }: NavBarProps) {
  const [showTitle, setShowTitle] = useState(true);
  const titleRef = useRef<HTMLDivElement>(null);
  const toolbarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkTitleFit = () => {
      if (!titleRef.current || !toolbarRef.current) return;
      
      const titleWidth = titleRef.current.scrollWidth;
      const titleVisibleWidth = titleRef.current.clientWidth;
      
      // If scrollWidth > clientWidth, text is being truncated
      setShowTitle(titleWidth <= titleVisibleWidth);
    };

    checkTitleFit();
    window.addEventListener('resize', checkTitleFit);
    return () => window.removeEventListener('resize', checkTitleFit);
  }, [title]);

  return (
    <AppBar position="sticky" sx={{ boxShadow: 'none', px: 2 }}>
      <Toolbar 
        ref={toolbarRef}
        disableGutters 
        sx={{ justifyContent: showTitle ? 'space-between' : 'flex-end' }}
      >
        <Box
          ref={titleRef}
          sx={{
            overflow: 'hidden',
            flex: showTitle ? '1 1 auto' : '0 0 0',
            minWidth: 0,
            opacity: showTitle ? 1 : 0,
            visibility: showTitle ? 'visible' : 'hidden',
            mr: showTitle ? 2 : 0,
            transition: 'opacity 0.2s'
          }}
        >
          <Typography 
            variant="h6" 
            sx={{ 
              fontWeight: 700,
              whiteSpace: 'nowrap'
            }}
          >
            {title || 'SPROUTCO'}
          </Typography>
        </Box>

        {showSectionNav && (
          <Stack direction="row" spacing={1}>
            <Button color="inherit" href="#about">About</Button>
            <Button color="inherit" href="#contact">Contact</Button>
            <Button variant="contained" color="primary" href="#book">Book</Button>
          </Stack>
        )}
      </Toolbar>
    </AppBar>
  );
}
